// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"f2e85c84","356":"ff1b83a0","480":"f21b09c3","588":"f312adc9","620":"a0602e58","624":"51aeffb6","648":"822c0a57","780":"2208a875","864":"94a869d7","912":"2812922c","928":"92606b47","980":"f419968e"}[chunkId] + ".chunk.js";
};